/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListMappedDataCutsResponseItem } from '../models/ListMappedDataCutsResponseItem';
import type { SurveyDataCut } from '../models/SurveyDataCut';
import type { SurveyDataCutSort } from '../models/SurveyDataCutSort';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DataCutService {

    /**
     * Get Survey Data Cuts
     * @returns any Success
     * @throws ApiError
     */
    public static listMappedDataCuts({
        surveyId,
        paymarketId,
        offset,
        limit,
        sort,
        organizations,
        incumbents,
        prevalence,
        jobsCount,
        search,
    }: {
        surveyId: string,
        paymarketId: number,
        /**
         * Page number
         */
        offset?: number,
        /**
         * Max items per page
         */
        limit?: number,
        sort?: SurveyDataCutSort,
        organizations?: number,
        incumbents?: number,
        prevalence?: number,
        jobsCount?: number,
        search?: string,
    }): CancelablePromise<{
        rows: Array<ListMappedDataCutsResponseItem>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/{surveyId}/mappedDataCut',
            path: {
                'surveyId': surveyId,
            },
            query: {
                'paymarketId': paymarketId,
                'offset': offset,
                'limit': limit,
                'sort': sort,
                'organizations': organizations,
                'incumbents': incumbents,
                'prevalence': prevalence,
                'jobsCount': jobsCount,
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Data Cuts
     * @returns SurveyDataCut Success
     * @throws ApiError
     */
    public static listDataCuts({
        surveyId,
        offset,
        limit,
        organizations,
        incumbents,
        prevalence,
        search,
        currencyId,
        sort,
    }: {
        surveyId: string,
        /**
         * Page number
         */
        offset?: number,
        /**
         * Max items per page
         */
        limit?: number,
        organizations?: number,
        incumbents?: number,
        prevalence?: number,
        search?: string,
        currencyId?: number,
        sort?: SurveyDataCutSort,
    }): CancelablePromise<Array<SurveyDataCut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/{surveyId}/dataCut',
            path: {
                'surveyId': surveyId,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'organizations': organizations,
                'incumbents': incumbents,
                'prevalence': prevalence,
                'search': search,
                'currencyId': currencyId,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
